import { useCallback } from 'react'
import ReactGA from 'react-ga'
import useUtils from './useUtils'

const useGoogleAnalytics = () => {
  const { isBlank } = useUtils()

  const event = useCallback((category, action, label = '') => {
    if (isBlank(process.env.GOOGLE_KEY)) {
      return
    }

    ReactGA.event({ category, action, label })
  }, [isBlank])

  return { event }
}

export default useGoogleAnalytics
